import { Component, OnInit, Inject, NgModule, Renderer2 } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TemplateRef } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { CountryService } from '../country.service';
import { NotificationsService, SimpleNotificationsModule, NotificationType } from 'angular2-notifications';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { NgZone } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { MasterService } from '../../../../../master.service';
import { Options } from 'angular2-notifications';
import { DeleteConfirmationModalComponent } from '../delete-confirmation-modal/delete-confirmation-modal.component';
import { BusyButtonDirective } from '../../../../../core/directives/busy-button.directive';

declare const $: any;

@Component({
  selector: 'app-country',
  standalone: true,
  imports: [BusyButtonDirective, RouterModule, HttpClientModule, CommonModule, SimpleNotificationsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule],
  templateUrl: './country.component.html',
  styleUrl: './country.component.scss'
})
export class CountryComponent implements OnInit {
  pageEvent: any;
  element: any = {};

  // Define notification options with the correct type
  notificationOptions: Options = {
    timeOut: 1000,             // Notification duration in ms
    showProgressBar: true,     // Show progress bar
    pauseOnHover: true,        // Pause timeout on hover
    clickToClose: true,
    position: ['top', 'right'],     // Close notification on click
  };

  countryList: any = [];
  selection = new SelectionModel<any>(false, []);
  dataSource = new MatTableDataSource<any>();

  length = 100;
  pageSizeOptions = [5, 10, 25, 100];
  pageSize = 10;
  currentPage = 0;
  totalElements = 0;
  totalPages = 0;
  Math = Math;

  constructor(
    private notifications: NotificationsService,
    public masterService: MasterService,
    public countryService: CountryService,
    private ngZone: NgZone,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.element.searchKey = null;
    this.element.page = this.currentPage;
    this.element.size = this.pageSize;
    this.element.sortField = "countryName";
    this.element.sortOrder = "asc";
    this.getList();
  }

  getList() {
    console.log("List called ", this.element);
    console.log("Service Object ", this.countryService);
    this.countryService.getCountries(this.element).subscribe(data => {
      console.log("received data ", data);
      this.countryList = data.content;
      this.totalElements = data.totalElements;
      this.totalPages = data.totalPages;
      this.length = this.totalElements;
      this.dataSource.data = this.countryList;
      console.log("this.countryList ", this.countryList);
    });
  }

  editCountry(index: any) {
    console.log("editCountry called ");
    this.masterService.checkFeature('MASTER.COUNTRY.MODIFY', '/masters/editcountry/' + this.countryList[index].id);
  }

  addCountry() {
    console.log("addCountry called ");
    this.masterService.checkFeature('MASTER.COUNTRY.CREATE', '/masters/addcountry');
  }

  deleteCountry(index: any) {
    console.log("Select country index  ", index);
    let country = this.countryList[index];
    console.log("Select country ", country);
    
    if (this.masterService.checkFeatureFound('MASTER.COUNTRY.DELETE') == false) {
      console.log("No permission to delete!!");
      return;
    }

    // Show confirmation dialog
    const modalRef = this.modalService.open(DeleteConfirmationModalComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
    
    modalRef.componentInstance.countryName = country.countryName;
    modalRef.componentInstance.countryCode = country.countryCode;
    
    modalRef.result.then((result) => {
      if (result === 'yes') {
        // User confirmed deletion
        this.performDelete(country.id);
      }
    }, (reason) => {
      // Modal was dismissed
      console.log('Delete operation cancelled');
    });
  }

  private performDelete(id: number) {
    this.countryService.delete(id).subscribe(data => {
      console.log("Received delete data ", data);
      if (data.status != true) {
        console.log("Error While deleting Country ", data.responseDescription);
        this.notifications.error('Error', 'Failed to delete Country');
        return;
      } else {
        console.log("delete success ", data);
        this.notifications.success('Success', 'Country deleted successfully');
        this.getList();
      }
    },
    error => {
      console.log("Country Deleted Not successfully.", error);
      this.notifications.error('Error', 'Failed to delete Country');
    });
  }

  searchKey() {
    console.log("searchKey called ");
    if (this.element == null || this.element == undefined)
      return;
    this.countryService.searchKey(this.element).subscribe({
      next: (data) => {
        this.ngZone.run(() => {
          this.countryList = data?.content.content || [];
        });
      },
      error: (err) => {
        console.error('Search error:', err);
      },
    });
  }

  clearSearch() {
    console.log("clearSearch called");
    if (this.element.searchKey != null) {
      this.element.searchKey = null;
      this.getList();
    }
  }

  onPageChange(event: any) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.element.page = this.currentPage;
    this.element.size = this.pageSize;
    this.getList();
  }
}
